import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { Adresa, Beneficiar, Localizare, Relationship } from '../../beneficiari.interface';
import { EditSubsemnatComponent } from './edit-subsemnat/edit-subsemnat.component';
import { MatDialog } from '@angular/material/dialog';
import { PermissionsService } from 'src/app/services/permissions.service';
import { helper } from 'src/environments/helper';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from 'src/app/services/dialog.service';
import Swal from 'sweetalert2';
import { BeneficiariService } from '../../beneficiari.service';
import { AddLocationComponent } from './add-location/add-location.component';
import { EditLocationComponent } from './edit-location/edit-location.component';
import { ViewIstoricLocalizareComponent } from './view-istoric-localizare/view-istoric-localizare.component';
import { AddRelationshipComponent } from './add-relationship/add-relationship.component';
import { EditRelationshipComponent } from './edit-relationship/edit-relationship.component';
import { ViewIstoricRelationshipComponent } from './view-istoric-relationship/view-istoric-relationship.component';
import { NotificationService } from 'src/app/services/notification.service';
import { ViewIstoricSubsemnatComponent } from './view-istoric-subsemnat/view-istoric-subsemnat.component';
import { AppFilesService } from 'src/app/services/app-files.service';

// const locationMockData = [
//     {
//         id: 1,
//         situation: 'În plasament',
//         date_from: '26.02.2025',
//         date_to: '13.01.2026',
//         address: 'Adresă plasament',
//     },
//     {
//         id: 2,
//         situation: 'În adopție',
//         date_from: '13.01.2026',
//         date_to: 'n/a',
//         address: 'Adresă de acasă',
//     },
// ]

// const relationshipMockData = [
//     {
//         id: 1,
//         nume: 'Marcel',
//         relationship_type: 'Relație părinte-copil',
//         relationship_specific: 'Tată',
//         relationship_status: 'Relația se dezvoltă pozitiv',
//         relationship_status_color: '#008000',
//         relationship_confirmation: 'Confirmat',
//         relationship_confirmation_color: '#008000',
//     },
//     {
//         id: 2,
//         nume: 'Maria',
//         relationship_type: 'Relație părinte-copil',
//         relationship_specific: 'Mamă',
//         relationship_status: 'Relația se desfășoară sub supraveghere',
//         relationship_status_color: '#FCD12A',
//         relationship_confirmation: 'Verificat',
//         relationship_confirmation_color: '#008000',
//     },
// ]

enum ViewMode {
    ACTIVE = 'active',
    INACTIVE = 'inactive',
    ALL = 'all'
}

@Component({
    selector: 'app-subsemnat',
    templateUrl: './subsemnat.component.html',
    styleUrls: ['./subsemnat.component.scss'],
})
export class SubsemnatComponent implements OnInit {
    @Input() beneficiar!: Beneficiar;
    @Output() beneficiarChanged: EventEmitter<Beneficiar> = new EventEmitter<Beneficiar>();
    selectedBeneficiarStatus = 'info';
    @Output() isLoading = new EventEmitter<boolean>();

    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    ViewMode = ViewMode;
    currentViewLocalizari: ViewMode = ViewMode.ACTIVE;
    currentViewRelationships: ViewMode = ViewMode.ACTIVE;

    filteredLocalizari: Localizare[] = [];
    filteredRelationships: Relationship[] = [];

    constructor(
        public dialog: MatDialog,
        private dialogService: DialogService,
        public beneficiariService: BeneficiariService,
        public permissionsService: PermissionsService,
        private notificationService: NotificationService,
        private appFilesService: AppFilesService,
        public toastr: ToastrService,
    ) { }

    ngOnInit(): void {
        this.filteredLocalizari = [...this.beneficiar.localizari];
        this.filteredRelationships = [...this.beneficiar.relationships];

        this.setViewModeLocalizari();
        this.setViewModeRelationships();
    }

    ngOnChanges(): void {
        // When beneficiar data changes run ViewMode again
        this.setViewModeLocalizari();
        this.setViewModeRelationships();
    }

    onBeneficiarInfoChange(event: MatButtonToggleChange) {
        this.selectedBeneficiarStatus = event.value;
    }

    formatDate(date: string): string {
        return new Date(date).toLocaleString('ro-RO');
    }

    openToast(object: any) {
        const { type, message, title } = object;

        let options = this.toastr.toastrConfig;
        options.progressBar = true;
        options.preventDuplicates = true;
        options.closeButton = true;

        const inserted = this.toastr.show(
            message,
            title,
            options,
            options.iconClasses[type]
        );
    }

    // showAddress(address: Adresa | null) {
    //     if (address) {
    //         return ('Jud: ' + (address.judet_nume ? address.judet_nume :
    //             'n/a') + ', ') +
    //             ('Oraș: ' + (address.localitate_nume ? address.localitate_nume :
    //                 'n/a') + ', ') +
    //             ('Sect: ' + (address.sector ? address.sector :
    //                 'n/a') + ', ') +
    //             ('Stradă: ' + (address.strada_nume ? address.strada_nume :
    //                 'n/a') + ', ') +
    //             ('Nr: ' + (address.numar ? address.numar :
    //                 'n/a') + ', ') +
    //             ('Bl: ' + (address.bloc ? address.bloc :
    //                 'n/a') + ', ') +
    //             ('Sc: ' + (address.scara ? address.scara :
    //                 'n/a') + ', ') +
    //             ('Et: ' + (address.etaj ? address.etaj :
    //                 'n/a') + ', ') +
    //             ('Ap: ' + (address.apartament ? address.apartament :
    //                 'n/a') + ', ') +
    //             ('CP: ' + (address.cod_postal ? address.cod_postal :
    //                 'n/a'))
    //     } else {
    //         return 'n/a'
    //     }
    // }

    setViewModeLocalizari(mode?: ViewMode): void {
        if (mode) {
            this.currentViewLocalizari = mode;
        }

        if (this.currentViewLocalizari === ViewMode.ACTIVE) {
            this.filteredLocalizari = this.beneficiar.localizari.filter(item => item.is_active && !item.is_deleted);
        } else if (this.currentViewLocalizari === ViewMode.INACTIVE) {
            this.filteredLocalizari = this.beneficiar.localizari.filter(item => !item.is_active || item.is_deleted);
        } else {
            this.filteredLocalizari = [...this.beneficiar.localizari];
        }
    }

    setViewModeRelationships(mode?: ViewMode): void {
        if (mode) {
            this.currentViewRelationships = mode;
        }

        if (this.currentViewRelationships === ViewMode.ACTIVE) {
            this.filteredRelationships = this.beneficiar.relationships.filter(item => item.is_active && !item.is_deleted);
        } else if (this.currentViewRelationships === ViewMode.INACTIVE) {
            this.filteredRelationships = this.beneficiar.relationships.filter(item => !item.is_active || item.is_deleted);
        } else {
            this.filteredRelationships = [...this.beneficiar.relationships];
        }
    }

    openEditSubsemnat() {
        const dialogRef = this.dialog.open(EditSubsemnatComponent, {
            width: '600px',
            maxWidth: '90vw',
            minHeight: '200px',
            maxHeight: '90vh',
            autoFocus: false,
            disableClose: true,
            data: {
                beneficiarData: this.beneficiar,
            },
        });
        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.beneficiarChanged.emit();
                this.openToast({
                    title: this.helper.dialogConfig.headers.success,
                    message: 'Date identificare actualizate cu succes',
                    type: this.helper.dialogConfig.icons.success,
                });
            }
        });
    }

    openIstoricSubsemnat() {
        const dialogRef = this.dialog.open(ViewIstoricSubsemnatComponent, {
            width: '700px',
            maxWidth: '80vw',
            minHeight: '200px',
            maxHeight: '90vh',
            autoFocus: false,
            disableClose: true,
            data: { idenificareHistory: this.beneficiar.identification_changes_history, beneficiar_id: this.beneficiar.id },
        });
        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.beneficiarChanged.emit();
            }
        });
    }

    openAddLocation() {
        const dialogRef = this.dialog.open(AddLocationComponent, {
            width: '1000px',
            maxWidth: '90vw',
            minHeight: '200px',
            maxHeight: '90vh',
            autoFocus: false,
            disableClose: true,
            data: {
                beneficiar: this.beneficiar,
            },
        });
        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.beneficiarChanged.emit();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Locație adăugată cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
        });
    }

    openEditLocation(row_id: number) {
        const dialogRef = this.dialog.open(EditLocationComponent, {
            width: '1000px',
            maxWidth: '90vw',
            minHeight: '200px',
            maxHeight: '90vh',
            autoFocus: false,
            disableClose: true,
            data: {
                beneficiar: this.beneficiar,
                row_id: row_id,
            },
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.beneficiarChanged.emit();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Locație actualizată cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
        });
    }

    openIstoricLocation(row: Localizare) {
        const dialogRef = this.dialog.open(ViewIstoricLocalizareComponent, {
            width: '700px',
            maxWidth: '80vw',
            minHeight: '200px',
            maxHeight: '90vh',
            autoFocus: false,
            disableClose: true,
            data: { row: row, beneficiar_id: this.beneficiar.id },
        });
        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.beneficiarChanged.emit();
            }
        });
    }

    deleteLocation(row_id: number) {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: this.helper.swalTextConfig.generalMessages.delete,
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: this.helper.swalTextConfig.buttonLabels.confirm,
            cancelButtonText: this.helper.swalTextConfig.buttonLabels.close,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            input: 'text', // Enable text input
            inputPlaceholder: 'Completați motivul ștergerii',
            inputValidator: (value: any) => {
                if (!value) {
                    return 'Este necesar să completați motivul ștergerii!';
                }
                return null; // Return null if input is valid
            },
            preConfirm: (inputValue) => {
                return this.beneficiariService
                    .deleteLocalizare(row_id, { motiv: inputValue })
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((err) => {
                        let msg;
                        try {
                            msg = err.error.errors.message[0];
                        } catch (error) {
                            msg = helper.dialogConfig.generalMessages.error;
                        }
                        this.notificationService.warningSwal(
                            this.errorTitle,
                            msg,
                            this.errorIcon
                        );
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.deleted,
                    text: 'Locație ștearsă cu succes.',
                    icon: 'success',
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.ok,
                }).then(() => {
                    this.beneficiarChanged.emit();
                });
            }
        });
    }

    resetLocation(row_id: number) {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: 'O să resetați locația',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: this.helper.swalTextConfig.buttonLabels.confirm,
            cancelButtonText: this.helper.swalTextConfig.buttonLabels.close,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            input: 'text', // Enable text input
            inputPlaceholder: 'Completați motivul resetării',
            inputValidator: (value: any) => {
                if (!value) {
                    return 'Este necesar să completați motivul resetării!';
                }
                return null; // Return null if input is valid
            },
            preConfirm: (inputValue) => {
                return this.beneficiariService
                    .deleteLocalizare(row_id, { motiv: inputValue })
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((err) => {
                        let msg;
                        try {
                            msg = err.error.errors.message[0];
                        } catch (error) {
                            msg = helper.dialogConfig.generalMessages.error;
                        }
                        this.notificationService.warningSwal(
                            this.errorTitle,
                            msg,
                            this.errorIcon
                        );
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.deleted,
                    text: 'Locație resetată cu succes.',
                    icon: 'success',
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.ok,
                }).then(() => {
                    this.beneficiarChanged.emit();
                });
            }
        });
    }

    openAddRelationship() {
        const dialogRef = this.dialog.open(AddRelationshipComponent, {
            ...this.dialogService.getDialogConfig(),
            data: {
                beneficiar: this.beneficiar,
            },
        });
        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.beneficiarChanged.emit();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Relație adăugată cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
        });
    }

    openEditRelationship(row_id: number) {
        const dialogRef = this.dialog.open(EditRelationshipComponent, {
            ...this.dialogService.getDialogConfig(),
            data: {
                beneficiar: this.beneficiar,
                row_id: row_id,
            },
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.beneficiarChanged.emit();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Relație actualizată cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
        });
    }

    openIstoricRelationship(row: Relationship) {
        const dialogRef = this.dialog.open(ViewIstoricRelationshipComponent, {
            width: '700px',
            maxWidth: '80vw',
            minHeight: '200px',
            maxHeight: '90vh',
            autoFocus: false,
            disableClose: true,
            data: { row: row, beneficiar_id: this.beneficiar.id },
        });
        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.beneficiarChanged.emit();
            }
        });
    }


    deleteRelationship(row_id: number) {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: this.helper.swalTextConfig.generalMessages.delete,
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: this.helper.swalTextConfig.buttonLabels.confirm,
            cancelButtonText: this.helper.swalTextConfig.buttonLabels.close,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            input: 'text', // Enable text input
            inputPlaceholder: 'Completați motivul ștergerii',
            inputValidator: (value: any) => {
                if (!value) {
                    return 'Este necesar să completați motivul ștergerii!';
                }
                return null; // Return null if input is valid
            },
            preConfirm: (inputValue) => {
                return this.beneficiariService
                    .deleteRelatie(row_id, { motiv: inputValue })
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((err) => {
                        let msg;
                        try {
                            // try to catch the message from server
                            msg = err.error.errors.message[0];
                        } catch (error) {
                            // controll output message
                            msg = helper.dialogConfig.generalMessages.error;
                        }
                        this.notificationService.warningSwal(
                            this.errorTitle,
                            msg,
                            this.errorIcon
                        );
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.deleted,
                    text: 'Relație ștearsă cu succes.',
                    icon: 'success',
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.ok,
                }).then(() => {
                    this.beneficiarChanged.emit();
                });
            }
        });
    }

    resetRelationship(row_id: number) {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: 'O să resetați relația',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: this.helper.swalTextConfig.buttonLabels.confirm,
            cancelButtonText: this.helper.swalTextConfig.buttonLabels.close,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            input: 'text', // Enable text input
            inputPlaceholder: 'Completați motivul resetării',
            inputValidator: (value: any) => {
                if (!value) {
                    return 'Este necesar să completați motivul resetării!';
                }
                return null; // Return null if input is valid
            },
            preConfirm: (inputValue) => {
                return this.beneficiariService
                    .deleteRelatie(row_id, { motiv: inputValue })
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((err) => {
                        let msg;
                        try {
                            // try to catch the message from server
                            msg = err.error.errors.message[0];
                        } catch (error) {
                            // controll output message
                            msg = helper.dialogConfig.generalMessages.error;
                        }
                        this.notificationService.warningSwal(
                            this.errorTitle,
                            msg,
                            this.errorIcon
                        );
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.deleted,
                    text: 'Relație resetată cu succes.',
                    icon: 'success',
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.ok,
                }).then(() => {
                    this.beneficiarChanged.emit();
                });
            }
        });
    }

    openInNewTab(idEntity: number) {
        const url = `#/beneficiari?id=${idEntity}`;
        window.open(url, '_blank');
    }

    downloadChanges(type: string, id: number) {
        this.isLoading.emit(true);
        const fullPath = this.beneficiariService.downloadChangesUrl + `${type}/${id}/${this.beneficiar.id}`;

        this.appFilesService.downloadFile(fullPath)
            .then(() => {
                this.isLoading.emit(false);
            })
            .catch(err => {
                console.error('Download doc error: ', err);
                this.isLoading.emit(false);
            })
    }
}
